<template>
  <div class="withdraw_wrap finance-page cash2-page">
    <div class="red_top_bg cash2-header">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="bars"
          size="18"
        />
      </div>
    </div>
    <div class="balance cash2-balance">
      <p>
        {{ utils_moneyMark() }} {{ data.money }}
      </p>
      <p>
        {{ $t('invest.availableBalance') }}   
      </p>
    </div>
    <div class="wrap_box wrap1 cash2-form">
      <div class="withdraw_wrap">
        <p>{{ $t('cash.amount') }}</p>
        <div class="flex_center">
          <span>{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money" 
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('cash.withdrawableAmount') + utils_moneyMark()+data.money"
            @input="changeAmount"
          >
          <!-- <span>{{actualAmount}}</span> -->
        </div>
        <p v-if="chargeTip">
          {{ chargeTip }}
        </p>
      </div>
      <div
        class="choose_bank"
        @click="show=true"
      >
        <div>
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div>
          <span>{{ bank_name }}</span>
          <van-icon
            name="arrow"
            color="#999"
          />
        </div>
      </div>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text=""
        :description="this.$t('cash.chooseWallet')"
        close-on-click-action
        @select="onSelect"
      />
      <p class="canal_tips">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>
    <div
      class="basic_btn cash2-submit"
      @click="write_psd = true;submitType = 1;"
    >
      {{ $t('utils.submit') }}
    </div>
    <van-popup
      v-model="write_psd"
      class="cash-password-popup"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              :key="i"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                <van-icon name="delete" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(Icon).use(ActionSheet);

    export default {
        name: "Cash2",
        data() {
            return {
                data: {},
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
				chargeTip:'',
				charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
				eye:1,
				show: false,
				bank_name:this.$t('cash.chooseWallet'),
				actions: [],
				setPwd:false,
				submitType:1,
				type:1,
				rate:1,
				mark:"$",
				actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			onSelect(item){
				this.chargeTip = "";
				this.actualAmount = "";
				this.form.money = "";
				this.show = false;
				this.bank_name = item.name;
				this.form.bank_id = item.value;
				this.charge = item.charge;
				this.type = item.type;
				this.rate = item.rate;
				this.mark = item.mark;
				if(item.charge>0){
					this.chargeTip = this.$t('cash.charge')+item.charge+"%";
				}else{
					this.chargeTip = "";
				}
				if(item.value==0){
					this.$router.push('/addcountUsdt')
				}
			},
			changeAmount(){
				this.chargeTip = "";
				var rateTip = "";
				var num = 2;
					// if(this.type==1){
					// 	if(this.rate>10000){
					// 		num = 8;
					// 	}else if(this.rate>1000){
					// 		num = 6;
					// 	}else if(this.rate>10){
					// 		num = 4;
					// 	}
					// 	this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
					// 	rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
					// }else{
						this.actualAmount = "≈"+this.mark+(this.form.money/this.rate).toFixed(num);
						rateTip = "≈ "+(this.form.money*this.charge/100).toFixed(num)+" "+this.mark+"";
					// }
				if(this.charge>0){
					this.chargeTip = this.$t('cash.charge')+""+rateTip;
					// this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
				}
			},
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.form.password = this.psd_val;
					if(this.submitType==1){
						this.submit();
					}else{
						this.setIniPwdSubmit();
					}
					
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank2').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(2);
					this.setPwd = r.data.intPwd;
                    var bankvalue = [];
                    r.data.bank.forEach(item => {
						var length = item.account.length;
						var account = item.account+"";
						var itemAccount = account.substr(length-10,length)
                        bankvalue.push({
                            name: item.bank+"(****"+itemAccount+")",
                            value: item.id,
							charge:item.charge,
							rate:item.rate,
							type:item.type,
							mark:item.mark
                        })
						this.onSelect(bankvalue[0]);
                    })
					bankvalue.push({
						name: this.$t('cash.addWallet'),
						value: 0,
						color:"#FF0000",
					})
					this.actions = bankvalue;
					
                });
            },
            submit() {
				this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
				if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                    this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                    return false;
                }
				if (!this.form.password) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply2', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
					password: this.form.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.submitType = 2;
				this.write_psd = true;
			}
        }
    };
</script>

<style lang="less" scoped>
	
	/deep/ .van-action-sheet__item {
		text-align: left;
	}
	/deep/ .van-popup--bottom{
		border-radius:0;
		padding-bottom: 15px;
	}
	.balance{
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		p:nth-child(1){
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #999;
			font-weight: bold;
		}
	}

    .wrap1 {
        margin: 10px;
		box-shadow: none;
		background: none;
		.choose_bank{
			width: 100%;
			background: #FFFFFF;
			border-radius: 5px;
			padding:15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 10px;
			div:nth-child(1){
				width: 20%;
				font-size: 14px;
				font-weight: bold;
				color: #999;
			}
			div:nth-child(2){
				width: 80%;
				text-align: right;
				font-size: 12px;
				font-weight: bold;
				color: #999;
			}
		}
		.withdraw_wrap{
			width: 100%;
			background: #ffffff;
			border-radius: 6px;
			padding: 16px 20px;
			margin-top: 10px;
			
			input{
				height: 18px;
				width: 85%;
				line-height: 18px;
				font-size: 14px;
			}
			div{
				span:nth-child(1){
					font-size: 18px;
					margin-right: 20px;
					font-weight: bold;
				}
				span:nth-child(2){
					font-size: 14px;
					margin-left: 20px;
					font-weight: bold;
					width: 15%;
					color: #999;
					text-align: right;
				}
			}
			p:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #999;
				margin-bottom: 20px;
			}
			p:nth-child(3){
				color: #999;
				margin-top: 20px;
			}
		
		}
    }
	.canal_tips {
		border-top: 1px solid #ECECEC;
		display: block;
		padding: 16px;
		border-radius: 5px;
		background-color: #FFFFFF;
		line-height: 24px;
		color: #114634;
		font-size: 12px;
		margin-top: 10px;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
		border-radius: 5px;
    }

    .cash-password-popup {
        width: 100%;
        max-width: 520px;
        overflow: hidden;
        border-radius: 22px 22px 0 0;
        background: #FFFFFF;
        box-shadow: 0 -10px 30px rgba(54, 39, 45, .12);
    }

    .psw_box {
        position: relative;
        padding-top: 24px;

        &::before {
            position: absolute;
            top: 10px;
            left: 50%;
            width: 34px;
            height: 4px;
            border-radius: 4px;
            background: #FF385C;
            content: '';
            transform: translateX(-50%);
        }
    }

    .cash-password-popup /deep/ .van-popup__close-icon {
        top: 17px;
        right: 18px;
        width: 26px;
        height: 26px;
        border: 1px solid #E8E5E6;
        border-radius: 50%;
        color: #8A8184;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        box-sizing: border-box;
    }

    .cash-password-popup /deep/ .van-password-input {
        margin: 18px 20px 24px;
    }

    .cash-password-popup /deep/ .van-password-input__security {
        height: 54px;
    }

    .cash-password-popup /deep/ .van-password-input__security::after {
        border: 0;
    }

    .cash-password-popup /deep/ .van-password-input__security li {
        margin-right: 7px;
        border: 1px solid #E8E5E6;
        border-radius: 10px;
        background: #FFFCFC;
        box-shadow: none;
    }

    .cash-password-popup /deep/ .van-password-input__security li:last-child {
        margin-right: 0;
    }

    .cash-password-popup /deep/ .van-password-input__cursor {
        background-color: #FF385C;
    }

    .keybord_box {
        padding: 14px 16px 26px;
        background: #F7F6F7;

        .keybord {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 10px;
            width: 100%;
            max-width: 430px;
            margin: 0 auto;
            text-align: center;

            .key_item {
                height: 54px;
                border: 1px solid #F0EDEF;
                border-radius: 12px;
                background: #FFFFFF;
                color: #252126;
                font-size: 16px;
                font-weight: 600;
                line-height: 54px;
                box-shadow: 0 2px 5px rgba(45, 35, 38, .04);
                transition: transform .16s ease, background-color .16s ease;

                &:active {
                    background: #FFE9EE;
                    transform: scale(.97);
                }

                &.no_bg {
                    border-color: transparent;
                    background: transparent;
                    box-shadow: none;
                }

                &.x {
                    border-color: #F2E5E8;
                    background: #FFF3F5;
                    color: #B4546C;
                }
            }

            .key_inner {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
            }
        }
    }
	
.finance-page {
	min-height: 100vh;
	padding-bottom: .48rem;
	box-sizing: border-box;
}

.finance-page .red_top_bg {
	height: 1.28rem;
	background: transparent;
	color: #222;
}

.finance-page .big_tit {
	top: .42rem;
	color: #222;
	font-size: .34667rem;
	font-weight: 700;
}

.finance-page .back_left {
	position: absolute;
	top: .3rem;
	left: .28rem;
	width: .48rem;
	height: .48rem;
	margin: 0;
	background: none;
}

.finance-page .back_left::after {
	color: #222;
	content: '‹';
	font-size: .64rem;
	font-weight: 300;
	line-height: .4rem;
}

.finance-page .top_right {
	top: .36rem;
	right: .36rem;
	color: #484848;
}

.finance-page .balance {
	margin: .08rem .4rem .3rem;
	padding: .36rem .4rem;
	border: .02667rem solid #ececec;
	border-radius: .26667rem;
	box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .05);
}

.finance-page .balance p:nth-child(1) {
	margin-bottom: .12rem;
	color: #222;
	font-size: .58667rem;
	letter-spacing: -.02rem;
}

.finance-page .balance p:nth-child(2) {
	color: #717171;
	font-size: .25333rem;
	font-weight: 500;
}

.finance-page .wrap1 {
	margin: 0 .4rem;
	padding: .08rem .32rem;
	border: .02667rem solid #ececec;
	border-radius: .26667rem;
	background: #fff;
	box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .04);
}

.finance-page .wrap1 .withdraw_wrap {
	margin: 0;
	padding: .3rem .08rem;
	border-radius: 0;
	box-shadow: none;
}

.finance-page .wrap1 .withdraw_wrap + .withdraw_wrap,
.finance-page .wrap1 .choose_bank {
	border-top: .02667rem solid #f0f0f0;
}

.finance-page .wrap1 .withdraw_wrap p:nth-child(1) {
	margin-bottom: .16rem;
	color: #484848;
	font-size: .26667rem;
	font-weight: 600;
}

.finance-page .wrap1 .withdraw_wrap input {
	width: 100%;
	height: .64rem;
	border: 0;
	border-bottom: .02667rem solid #ddd;
	border-radius: 0;
	color: #222;
	font-size: .33333rem;
}

.finance-page .wrap1 .withdraw_wrap .flex_center > span:first-child {
	width: auto;
	margin-right: .16rem;
	color: #ff385c;
	font-size: .36rem;
}

.finance-page .wrap1 .choose_bank {
	margin: 0;
	padding: .3rem .08rem;
	border-radius: 0;
	box-shadow: none;
}

.finance-page .wrap1 .choose_bank div:nth-child(1) {
	color: #484848;
	font-size: .26667rem;
	font-weight: 600;
}

.finance-page .wrap1 .choose_bank div:nth-child(2) {
	color: #717171;
	font-size: .24rem;
	font-weight: 400;
}

.finance-page .canal_tips {
	margin: 0;
	padding: .24rem .08rem .18rem;
	border: 0;
	border-top: .02667rem solid #f0f0f0;
	border-radius: 0;
	box-shadow: none;
	color: #8a8a8a;
	font-size: .22667rem;
	line-height: .36rem;
}

.finance-page > .basic_btn {
	width: calc(100% - .8rem);
	height: .96rem;
	margin: .32rem .4rem 0;
	border-radius: .2rem;
	background: #ff385c;
	box-shadow: 0 .13333rem .24rem rgba(255, 56, 92, .22);
	color: #fff;
	font-size: .32rem;
	font-weight: 600;
	line-height: .96rem;
}

.finance-page /deep/ .van-popup--bottom {
	position: fixed;
	border-radius: .26667rem .26667rem 0 0;
}

/* Premium USDT withdrawal layout: keep the original form behaviour, refine only its presentation. */
.finance-page {
	position: relative;
	overflow: hidden;
}

.finance-page::before {
	position: absolute;
	top: 1.05rem;
	right: -.8rem;
	width: 3.2rem;
	height: 3.2rem;
	border-radius: 50%;
	background: radial-gradient(circle, rgba(255, 56, 92, .12), transparent 67%);
	content: '';
	pointer-events: none;
}

.finance-page .red_top_bg {
	position: relative;
	z-index: 1;
	height: 1.33333rem;
	border-bottom: .02667rem solid rgba(235, 235, 235, .9);
	background: rgba(255, 255, 255, .86);
	backdrop-filter: blur(.26667rem);
}

.finance-page .big_tit {
	top: 0;
	height: 1.33333rem;
	font-size: .32rem;
	line-height: 1.33333rem;
}

.finance-page .back_left {
	top: 0;
	left: 0;
	width: 1.17333rem;
	height: 1.33333rem;
}

.finance-page .back_left::after {
	position: absolute;
	top: .48rem;
	left: .45333rem;
	width: .26667rem;
	height: .26667rem;
	border-bottom: .05333rem solid #3c3c3c;
	border-left: .05333rem solid #3c3c3c;
	color: transparent;
	content: '';
	transform: rotate(45deg);
}

.finance-page .top_right {
	top: 0;
	right: 0;
	box-sizing: border-box;
	display: flex;
	width: 1.17333rem;
	height: 1.33333rem;
	align-items: center;
	justify-content: center;
	color: #484848;
}

.finance-page .balance {
	position: relative;
	z-index: 1;
	overflow: hidden;
	margin: .32rem .4rem .3rem;
	padding: .4rem .4rem .36rem;
	border: .02667rem solid rgba(255, 255, 255, .14);
	border-radius: .26667rem;
	background: linear-gradient(125deg, #242426 0%, #34232b 60%, #792640 145%);
	box-shadow: 0 .18667rem .37333rem rgba(44, 27, 35, .18);
	text-align: left;
}

.finance-page .balance::after {
	position: absolute;
	top: -.62rem;
	right: -.44rem;
	width: 2rem;
	height: 2rem;
	border: .02667rem solid rgba(255, 255, 255, .13);
	border-radius: 50%;
	box-shadow: 0 0 0 .32rem rgba(255, 255, 255, .04);
	content: '';
}

.finance-page .balance p {
	position: relative;
	z-index: 1;
}

.finance-page .balance p:nth-child(1) {
	margin-bottom: .1rem;
	color: #fff;
	font-size: .56rem;
	font-weight: 700;
	letter-spacing: -.02667rem;
}

.finance-page .balance p:nth-child(2) {
	color: rgba(255, 255, 255, .68);
	font-size: .24rem;
	font-weight: 500;
}

.finance-page .wrap1 {
	position: relative;
	z-index: 1;
	margin: 0 .4rem;
	padding: .1rem .32rem;
	border: .02667rem solid rgba(235, 235, 235, .95);
	border-radius: .26667rem;
	background: rgba(255, 255, 255, .96);
	box-shadow: 0 .13333rem .32rem rgba(50, 40, 48, .07);
}

.finance-page .wrap1 .withdraw_wrap {
	padding: .32rem .08rem;
}

.finance-page .wrap1 .withdraw_wrap p:nth-child(1),
.finance-page .wrap1 .choose_bank div:nth-child(1) {
	color: #343036;
	font-size: .25333rem;
	font-weight: 700;
}

.finance-page .wrap1 .withdraw_wrap .flex_center {
	box-sizing: border-box;
	display: flex;
	height: .84rem;
	align-items: center;
	padding: 0 .2rem;
	border: .02667rem solid #eee9ec;
	border-radius: .16rem;
	background: #faf9fa;
}

.finance-page .wrap1 .withdraw_wrap .flex_center > span:first-child {
	margin-right: .12rem;
	color: #e31c5f;
	font-size: .32rem;
}

.finance-page .wrap1 .withdraw_wrap input {
	height: .72rem;
	border: 0;
	background: transparent;
	font-size: .29333rem;
}

.finance-page .wrap1 .withdraw_wrap input::placeholder {
	color: #99929a;
	-webkit-text-fill-color: #99929a;
}

.finance-page .wrap1 .choose_bank {
	display: flex;
	min-height: 1.12rem;
	align-items: center;
	padding: 0 .08rem;
}

.finance-page .wrap1 .choose_bank div:nth-child(2) {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	color: #777078;
	font-size: .24rem;
}

.finance-page .canal_tips {
	padding: .22rem .08rem .26rem .22rem;
	border-left: .05333rem solid #ff385c;
	color: #817981;
	font-size: .22667rem;
	line-height: .36rem;
}

.finance-page > .basic_btn {
	position: relative;
	z-index: 1;
	height: 1rem;
	margin-top: .34rem;
	border-radius: .21333rem;
	background: linear-gradient(100deg, #ff4d72, #d71e61);
	box-shadow: 0 .16rem .29333rem rgba(227, 28, 95, .2);
	font-size: .29333rem;
	line-height: 1rem;
}

.finance-page /deep/ .van-action-sheet__header {
	color: #222;
	font-size: .29333rem;
	font-weight: 700;
}

/* Cash withdrawal visual system: the source image remains the page background. */
.cash2-page {
	position: relative;
	min-height: 100vh;
	padding-bottom: .64rem;
	overflow: visible;
	box-sizing: border-box;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.cash2-page::before {
	display: none;
}

.cash2-page .cash2-header {
	position: relative;
	height: 1.4rem;
	border: 0;
	border-bottom: .01333rem solid rgba(255, 255, 255, .16);
	background: rgba(21, 38, 60, .96);
	box-shadow: 0 .1rem .28rem rgba(16, 31, 49, .14);
}

.cash2-page .cash2-header .big_tit {
	top: 0;
	height: 1.4rem;
	color: #fff;
	font-size: .32rem;
	font-weight: 700;
	letter-spacing: .01rem;
	line-height: 1.4rem;
}

.cash2-page .cash2-header .back_left {
	z-index: 1;
	top: 0;
	left: .18rem;
	width: .88rem;
	height: 1.4rem;
}

.cash2-page .cash2-header .back_left::after {
	top: .5rem;
	left: .22rem;
	width: .24rem;
	height: .24rem;
	border-width: 0 0 .04rem .04rem;
	border-color: #fff;
	color: transparent;
}

.cash2-page .cash2-header .top_right {
	top: 0;
	right: .14rem;
	width: .88rem;
	height: 1.4rem;
	color: rgba(255, 255, 255, .92);
}

.cash2-page .cash2-header .top_right /deep/ .van-icon {
	font-size: .4rem !important;
}

.cash2-page .cash2-balance {
	position: relative;
	overflow: hidden;
	margin: .34rem .32rem .28rem;
	padding: .36rem .4rem;
	border: .01333rem solid rgba(255, 255, 255, .22);
	border-radius: .24rem;
	background: linear-gradient(118deg, #142942, #263f5c 65%, #582c41);
	box-shadow: 0 .2rem .38rem rgba(23, 39, 61, .2);
	text-align: left;
}

.cash2-page .cash2-balance::after {
	top: -.58rem;
	right: -.42rem;
	width: 1.9rem;
	height: 1.9rem;
	border-color: rgba(255, 255, 255, .18);
	box-shadow: 0 0 0 .28rem rgba(255, 255, 255, .05);
}

.cash2-page .cash2-balance p {
	position: relative;
	z-index: 1;
	white-space: nowrap;
}

.cash2-page .cash2-balance p:nth-child(1) {
	margin-bottom: .1rem;
	color: #fff;
	font-size: .56rem;
	font-weight: 700;
	letter-spacing: -.02667rem;
}

.cash2-page .cash2-balance p:nth-child(2) {
	color: rgba(255, 255, 255, .72);
	font-size: .24rem;
	font-weight: 500;
}

.cash2-page .cash2-form {
	position: relative;
	margin: 0 .32rem;
	padding: .1rem .34rem .04rem;
	border: .01333rem solid rgba(255, 255, 255, .9);
	border-radius: .26rem;
	background: rgba(255, 255, 255, .96);
	box-shadow: 0 .18rem .4rem rgba(28, 42, 61, .12);
}

.cash2-page .cash2-form .withdraw_wrap {
	padding: .3rem 0 .26rem;
}

.cash2-page .cash2-form .withdraw_wrap p:nth-child(1),
.cash2-page .cash2-form .choose_bank div:nth-child(1) {
	margin-bottom: .16rem;
	color: #28384c;
	font-size: .26667rem;
	font-weight: 700;
}

.cash2-page .cash2-form .flex_center {
	box-sizing: border-box;
	display: flex;
	height: .9rem;
	align-items: center;
	padding: 0 .2rem;
	border: .01333rem solid #e7eaef;
	border-radius: .14rem;
	background: #f8fafc;
}

.cash2-page .cash2-form .withdraw_wrap .flex_center > span:first-child {
	flex: 0 0 auto;
	margin-right: .12rem;
	color: #e82b59;
	font-size: .34rem;
	font-weight: 700;
}

.cash2-page .cash2-form .withdraw_wrap input {
	min-width: 0;
	height: .72rem;
	padding: 0;
	border: 0;
	background: transparent;
	color: #18283b;
	font-size: .28rem;
	line-height: .72rem;
	outline: none;
}

.cash2-page .cash2-form .withdraw_wrap input::placeholder {
	color: #929aa6;
	font-size: .26667rem;
	-webkit-text-fill-color: #929aa6;
}

.cash2-page .cash2-form .withdraw_wrap p:nth-child(3) {
	margin: .14rem 0 0;
	color: #e82b59;
	font-size: .22667rem;
	line-height: .32rem;
}

.cash2-page .cash2-form .choose_bank {
	display: flex;
	min-height: 1.08rem;
	align-items: center;
	margin: 0;
	padding: 0;
	border-top: .01333rem solid #edf0f4;
	border-radius: 0;
	background: transparent;
}

.cash2-page .cash2-form .choose_bank div:nth-child(1) {
	flex: 0 0 1.6rem;
	width: auto;
	margin: 0;
}

.cash2-page .cash2-form .choose_bank div:nth-child(2) {
	min-width: 0;
	flex: 1;
	width: auto;
	color: #657286;
	font-size: .24rem;
	font-weight: 400;
	text-align: right;
}

.cash2-page .cash2-form .choose_bank div:nth-child(2) span {
	display: inline-block;
	max-width: calc(100% - .42rem);
	overflow: hidden;
	vertical-align: middle;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.cash2-page .cash2-form .choose_bank /deep/ .van-icon {
	margin-left: .1rem;
	vertical-align: middle;
	color: #7d8998 !important;
}

.cash2-page .cash2-form .canal_tips {
	margin: 0;
	padding: .22rem 0 .24rem .2rem;
	border: 0;
	border-top: .01333rem solid #edf0f4;
	border-left: .04667rem solid #ff4668;
	border-radius: 0;
	background: transparent;
	color: #778294;
	font-size: .22667rem;
	line-height: .34rem;
	word-break: break-word;
}

.cash2-page > .cash2-submit {
	position: relative;
	z-index: 1;
	width: calc(100% - .64rem);
	height: 1rem;
	margin: .34rem .32rem 0;
	border-radius: .18rem;
	background: linear-gradient(100deg, #ff4d6c, #df2352);
	box-shadow: 0 .16rem .3rem rgba(223, 35, 82, .24);
	color: #fff;
	font-family: inherit;
	font-size: .3rem;
	font-weight: 700;
	letter-spacing: .015rem;
	line-height: 1rem;
}

.cash2-page /deep/ .van-action-sheet {
	border-radius: .26rem .26rem 0 0;
	font-family: inherit;
}

.cash2-page /deep/ .van-action-sheet__header {
	color: #23344a;
	font-size: .29333rem;
	font-weight: 700;
}

.cash2-page /deep/ .van-action-sheet__item {
	color: #46566b;
	font-size: .28rem;
}

/* Match the withdrawal gateway: one calm visual system and a 12/14/16px type scale. */
.cash2-page {
	padding: 0 0 72px;
}

.cash2-page .cash2-header {
	height: 50px;
	border: 0;
	border-bottom: 1px solid rgba(235, 235, 235, .9);
	border-radius: 0;
	background: rgba(255, 255, 255, .9);
	box-shadow: none;
	backdrop-filter: blur(10px);
}

.cash2-page .cash2-header .big_tit {
	top: 0;
	height: 50px;
	color: #202b3d;
	font-size: 16px;
	line-height: 50px;
}

.cash2-page .cash2-header .back_left {
	top: 0;
	left: 0;
	width: 44px;
	height: 50px;
}

.cash2-page .cash2-header .back_left::after {
	top: 18px;
	left: 17px;
	width: 11px;
	height: 11px;
	border-width: 0 0 2px 2px;
	border-color: #26364e;
	color: transparent;
	content: '';
	transform: rotate(45deg);
}

.cash2-page .cash2-header .top_right {
	top: 0;
	right: 0;
	display: flex;
	width: 44px;
	height: 50px;
	align-items: center;
	justify-content: center;
	color: #26364e;
}

.cash2-page .cash2-header .top_right /deep/ .van-icon {
	font-size: 20px !important;
}

.cash2-page .cash2-balance {
	margin: 16px 16px 12px;
	padding: 18px 20px;
	border-radius: 16px;
	background: linear-gradient(125deg, #1d304d, #355678 72%, #4a617f);
	box-shadow: 0 10px 24px rgba(25, 46, 75, .2);
}

.cash2-page .cash2-balance p:nth-child(1) {
	font-size: 16px;
	line-height: 1.3;
}

.cash2-page .cash2-balance p:nth-child(2) {
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
}

.cash2-page .cash2-form {
	margin: 0 16px;
	padding: 4px 14px;
	border-radius: 16px;
	background: rgba(255, 255, 255, .97);
	box-shadow: 0 8px 22px rgba(35, 50, 73, .08);
}

.cash2-page .cash2-form .withdraw_wrap {
	padding: 16px 2px;
}

.cash2-page .cash2-form .withdraw_wrap p:nth-child(1),
.cash2-page .cash2-form .choose_bank div:nth-child(1) {
	margin-bottom: 8px;
	font-size: 14px;
	line-height: 1.4;
}

.cash2-page .cash2-form .flex_center {
	height: 44px;
	padding: 0 10px;
	border-radius: 10px;
}

.cash2-page .cash2-form .withdraw_wrap .flex_center > span:first-child {
	font-size: 16px;
}

.cash2-page .cash2-form .withdraw_wrap input,
.cash2-page .cash2-form .withdraw_wrap input::placeholder {
	height: 42px;
	font-size: 14px;
}

.cash2-page .cash2-form .withdraw_wrap p:nth-child(3) {
	font-size: 12px;
	line-height: 1.5;
}

.cash2-page .cash2-form .choose_bank {
	min-height: 54px;
	padding: 0 2px;
}

.cash2-page .cash2-form .choose_bank div:nth-child(2) {
	font-size: 14px;
}

.cash2-page .cash2-form .canal_tips {
	padding: 10px 2px 12px 10px;
	font-size: 12px;
	line-height: 1.5;
}

.cash2-page > .cash2-submit {
	width: calc(100% - 32px);
	height: 48px;
	margin: 14px 16px 0;
	border-radius: 12px;
	font-size: 16px;
	line-height: 48px;
}

.cash2-page /deep/ .van-action-sheet__header,
.cash2-page /deep/ .van-action-sheet__item {
	font-size: 14px;
}
</style>
